<template>
	<div>

		<div v-if="userInfo" style="display: flex;align-items: center;" class="nav-buttons">
			<el-dropdown trigger="click">
				<div class="info">
					<!-- <span class="el-dropdown-link">{{ userInfo.userName }}</span>
				<i class="el-icon-arrow-down"></i> -->
					<el-button icon="el-icon-s-custom" circle size="mini" slot="reference"></el-button>
				</div>
				<el-dropdown-menu slot="dropdown">
					<el-dropdown-item @click.native="toAi" icon="el-icon-files">个人文件</el-dropdown-item>
					<el-dropdown-item @click.native="toSetting" icon="el-icon-set-up" divided>账户中心</el-dropdown-item>
					<el-dropdown-item @click.native="toOrder" icon="el-icon-time">交易记录</el-dropdown-item>
					<el-dropdown-item @click.native="toindex" icon="el-icon-house">官网首页</el-dropdown-item>
					<!-- <el-dropdown-item  @click.native="$route.path != '/zsk'?$router.push('/zsk'):''" icon="el-icon-house">知识库区</el-dropdown-item>  -->
					<!-- <el-dropdown-item  @click.native="$router.push('/school')" icon="el-icon-tickets">精品课程</el-dropdown-item>  -->

					<el-dropdown-item @click.native="$route.path != '/bbs/index' ? $router.push(`/bbs`) : ''"
						icon="el-icon-chat-line-round">互动交流</el-dropdown-item>
					<el-popover placement="right" width="220" trigger="hover">
						<div style="text-align: center;">
							<el-image style="width: 200px; height: 200px" :src="require('@/assets/yanyan.png')"
								fit="contain"></el-image>
							<!-- <p>扫码联系</p> -->
						</div>
						<el-dropdown-item icon="el-icon-service" slot="reference">在线客服</el-dropdown-item>
					</el-popover>

					<!-- <el-dropdown-item @click.native="changePass"  icon="el-icon-plus">个人信息</el-dropdown-item> -->
					<el-dropdown-item @click.native="loginOut" icon="el-icon-switch-button"
						divided>退出登录</el-dropdown-item>
				</el-dropdown-menu>
			</el-dropdown>

			<el-popover placement="bottom" width="400" popper-class="mes-el-popover" trigger="click">
				<el-card class="box-card" :body-style="{}">
					<div slot="header" class="clearfix">
						<span>全部通知</span>
					</div>
					<div v-if="mes">
						<el-alert type="info" @close="closeMes">
							<template slot="title">
								<span class="custom-title">{{ userInfo.userName }} </span>
							</template>
							<template slot>
								<div class="custom-description">

									<div>
										充值成功：订单号为：{{ mes.outTradeNo }}， <br>充值金额为：{{ mes.amount }}，到账积分为：{{ mes.credit
										}}
										<br>交易时间：{{ mes.dataTime | formatDate('Y年M月D日') }}
									</div>
									<!-- <el-button type="text" size="mini">查看详情</el-button> -->
								</div>
							</template>
						</el-alert>

					</div>
					<div v-else>
						<div style="text-align: center;">
							<i class="el-icon-chat-dot-round"></i> 没有新通知
						</div>

					</div>

				</el-card>
				<el-button icon="el-icon-message-solid" circle size="mini" slot="reference"></el-button>
			</el-popover>

		</div>
		<div v-else class="showLoginOut" :class="color">
			<el-button @click="openLoginDialog" plain class="loginBtn">登录</el-button>
			<el-button @click="openLoginDialog" type="primary" class="regBtn">注册</el-button>
		</div>

		<update-user :regDialogVisible="updateDialogVisible"></update-user>

	</div>
</template>

<script>
import updateUser from "@/components/dialog/updateUser"

import {
	mapState,
	mapActions,
	mapMutations
} from "vuex";
import {
	logout,
	removeUser
} from "@/api/index";
export default {
	name: 'HelloWorld',
	props: {
		msg: String,
		color: String
	},
	data() {
		return {
			updateDialogVisible: false,

		}
	},
	computed: {
		...mapState({
			userInfo: (state) => state.login.userInfo,
			mes: (state) => state.login.mes,
		}),
	},

	filters: {

		formatDate: function (timestamp, format = 'Y-M-D H:I:S') {


			if (!timestamp) return '无效时间戳';

			// 判断是秒还是毫秒 (10位是秒，13位是毫秒)
			const date = new Date(
				timestamp.toString().length === 10 ? timestamp * 1000 : parseInt(timestamp)
			);

			if (isNaN(date.getTime())) return '时间戳格式错误';

			const year = date.getFullYear();
			const month = String(date.getMonth() + 1).padStart(2, '0');
			const day = String(date.getDate()).padStart(2, '0');
			const hours = String(date.getHours()).padStart(2, '0');
			const minutes = String(date.getMinutes()).padStart(2, '0');
			const seconds = String(date.getSeconds()).padStart(2, '0');

			// 根据格式字符串替换
			return format
				.replace(/Y/g, year)
				.replace(/M/g, month)
				.replace(/D/g, day)
				.replace(/H/g, hours)
				.replace(/I/g, minutes)
				.replace(/S/g, seconds);
		},
	},
	components: {
		updateUser,

	},
	mounted() {
		// console.log(this.color,this.$route.path);


	},
	methods: {
		...mapActions(["updateLogoutData"]),
		...mapMutations(['set_user_mes']),
		async openLoginDialog() {

			// 检查登录状态
			if (!this.$store.getters.isLoggedIn) {
				// this.$login(() => {

				// })
				const userResult = await this.$login()
				console.log('登录返回结果:', userResult)

				//昵称 行业 单位
				if (userResult && userResult.data && (!userResult.data.nickName || !userResult.data.profession)) {
					this.updateDialogVisible = true

				}
				return
			}

		},
		closeMes() {
			this.set_user_mes(null)

		},
		toAi() {
			if (this.userInfo) {
				this.$route.path != '/ai' && this.$router.push({
					name: "ai",
				});
			} else {
				this.$message.error('请先登录！');

			}

		},
		toSetting() {
			this.$route.path != '/setting' && this.$router.push({
				name: "setting",
			});
		},
		toindex() {

			this.$route.path != '/' && this.$router.push({
				name: "index",
			});



		},
		toOrder() {
			this.$route.path != '/order' && this.$router.push({
				name: "order",
			});
		},
		loginOut() {
			logout().then((resp) => {
				if (resp.code === 200) {
					this.updateLogoutData()
					this.toindex()
					// this.$store.dispatch("tabsView/delAllOpendViews");
					// sessionStorage.clear();
					// this.CLEAR_EXPANDED_IDS();
					// this.$router.push({
					//   name: "login",
					// });
				}
			});
		},
	}

}
</script>

<style scoped lang="scss">
.info {
	margin-right: 8.0px;
}

.showLoginOut {
	display: flex;
}

.showLoginOut.blue .el-button--text {
	color: #409EFF;
}

.info {
	color: #fff;
}

.el-alert {
	margin-bottom: 8.0px;
}

.loginBtn {
	width: 76.8px;
	height: 33.6px;
	display: flex;
	justify-content: center;
	align-items: center;

	border: 1.6px solid;
	//  border-image: linear-gradient(268deg, rgba(0, 98, 223, 1), rgba(92, 163, 255, 1)) 2 2; 
	border-radius: 6.4px 6.4px 6.4px 6.4px;
	background-color: transparent;

	font-family: PingFang SC, PingFang SC;
	font-weight: bold;
	font-size: 12.8px;
	color: #005FD8;
	text-align: left;
	font-style: normal;
	text-transform: none;
	margin-right: 16.0px;
}

.regBtn {
	display: flex;
	justify-content: center;
	align-items: center;
	width: 76.8px;
	height: 33.6px;
	background: linear-gradient(270deg, #0062DF 0%, #5CA3FF 99%);
	border-radius: 6.4px 6.4px 6.4px 6.4px;
}
</style>
